import { useState, useEffect } from "react";

export default function useIsMobilei() {
  const [isMobilei, setIsMobilei] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const checkDevice = () => {
      setIsMobilei(window.innerWidth <= 768);
    };

    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  return { isMobilei };
}
